import Vue from "vue";
export default async (token) => {
  return new Promise((resolve) => {
    Vue.ws.disconnect()
    Vue.ws.connect(
        {
            wsDomain: process.env.VUE_APP_SOCKET_URL, 
            jwtToken: token
        }, 
        { 
            path: process.env.VUE_APP_SOCKET_PATH, 
            reconnectionAttempts: 300, 
            reconnectionDelay: 5000 
        }
    );
    Vue.ws.socket.on("open", () => {      
      resolve()
    });    
  })
};